// removed by extract-text-webpack-plugin
module.exports = {"container":"pages-productions-container","header":"pages-productions-header","title":"pages-productions-title","section":"pages-productions-section","col":"pages-productions-col","cols":"pages-productions-cols","colMenu":"pages-productions-colMenu","loading":"pages-productions-loading","menu":"pages-productions-menu","item":"pages-productions-item","current":"pages-productions-current","link":"pages-productions-link","list":"pages-productions-list","row":"pages-productions-row","card":"pages-productions-card"};


//////////////////
// WEBPACK FOOTER
// ./styles/pages/productions.scss
// module id = 818
// module chunks = 246